// extracted by mini-css-extract-plugin
module.exports = {"Alerts":"styles_Alerts__QuHUw","Alert":"styles_Alert__q3iz6","CloseIcon":"styles_CloseIcon__isY1n","text":"styles_text__f6vmE"};